module.exports = __webpack_public_path__ + "img/template2-old.41eaddcb.png";